import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AngularFireDatabase } from 'angularfire2/database';


@Injectable()
export class MenuProvider {

    private listName: any = '/menus';

    constructor(
        private afData: AngularFireDatabase
    ) { };

    private getGlobalListName(uid: any) {
        return this.listName + '/' + uid;
    }

    private getListName(uid: any, rid: any) {
        return this.getGlobalListName(uid) + '/' + rid;
    }

    list(uid, rid): Observable<any> {
        return this.afData.list(this.getListName(uid, rid)).snapshotChanges().map(items => {
				    return items.map(item => ({ key: item.key, ...item.payload.val() }));
			  });
    }
}


// WEBPACK FOOTER //
// /Users/nikolay/Documents/GitHub/menu-web/src/app/providers/menu.ts